import React, { useEffect, useState } from 'react';
import { useParams, NavLink,Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { useDispatch } from 'react-redux';
import { ADD } from '../redux/actions/action';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from '../Config';
function Product() {
    const { id } = useParams();
    const token = localStorage.getItem('token'); // Use token from localStorage
    const [productList, setProductList] = useState([]);
    const dispatch = useDispatch();

    // Fetch product data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/api/web_product_list`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setProductList(response.data.product_list);
            } catch (error) {
                console.error('Error fetching product data:', error);
            }
        };
        fetchData();
    }, [id, token]);

    const send = (product) => {
        const quantity = 1;  // Set the default quantity for the product

        // Display success alert when item is added to cart
        Swal.fire({
            icon: 'success',
            title: `${product.product_name} Item Added to Cart`,
            text: 'Successfully!',
        });

        // Create a new product object with quantity
        const productWithQuantity = { ...product, qnty: quantity };

        // Dispatch action to add product to the cart
        dispatch(ADD(productWithQuantity));
    };
    
    return (
        <section className="shop-section">
            <div className="auto-container">
                <div className="sec-title">
                    <h2>Our Products</h2>
                    <span className="separator" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets_web/images/icons/separator-1.png)` }}></span>
                </div>
                <div className="sortable-masonry">
                    <div className="items-container row clearfix">
                        {productList.map((product) => (
                            <div key={product.id} className="col-lg-3 col-md-6 col-sm-12 shop-block masonry-item small-column best_seller new_arraivals">
                                <div className="shop-block-one">
                                    <div className="inner-box">
                                        <figure className="image-box">
                                            <img src={`${BASE_URL}/public/uploads/products/${product.images[0]}`} alt={product.product_name} style={{width:'302px', height:'312px'}} />
                                            <ul className="info-list clearfix">
                                                <li><a href="index.html"><i className="flaticon-heart"></i></a></li>
                                                <li>
                                                    <Button variant="primary" onClick={() => send(product)} className="btn btn-dark col-lg-12">
                                                        Add to Cart
                                                    </Button>
                                                </li>
                                                <li>
                                                    <NavLink to={`/productdetails/${product.id}`}>
                                                       <a href={`${BASE_URL}/public/uploads/products/${product.images[0]}`} className="lightbox-image" data-fancybox="gallery">
                                                         <i className="flaticon-search"></i>
                                                        </a></NavLink>
                                                </li>
                                            </ul>
                                        </figure>
                                        <div className="lower-content">
                                    <NavLink to={`/productdetails/${product.id}`}>
                                        {product.product_name} 
                                    </NavLink>
                                    <hr />

                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                        <span className="price"><strong>Rs. {product.price} </strong></span>

                                        <Button
                                        variant="primary"
                                        onClick={() => send(product)}
                                        className="btn"
                                        style={{
                                            backgroundColor: "#005383ff",
                                            padding: "5px 15px",
                                            borderRadius: "20px",
                                                margin: "0 17px 17px",
                                                    border: "1px solid #007cc2"
                                        }}
                                        >
                                        Add to Cart
                                        </Button>
                                    </div>
                                    </div>
                                   </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="more-btn centred">
                    <Link to={`/products`} className="theme-btn-one">View All Products<i className="flaticon-right-1"></i></Link>
                </div>
            </div>
        </section>
    );
}

export default Product;
